<template>
    <div v-if="widgetReady">
        <top-bar :consultant-id="consultantId">
        </top-bar>
        <router-view></router-view>
        <ac-footer></ac-footer>
        <inactivity-modal></inactivity-modal>
    </div>
</template>
<script>
    import TopBar from "./components/TopBar.vue";
    import {common} from "../../global/common.js";
    import InactivityModal from "../../components/shared/InactivityModal.vue";

    export default {
        name: "consultant",
        components: {TopBar, InactivityModal},
        data() {
            return {
                widgetReady: false,
                prevConsultantId: null,
                consultantId: 0
            }
        },
        watch: {
            '$route.params.consultantId': {
                handler(consultantId) {
                    if (consultantId && (Number(consultantId) !== Number(this.prevConsultantId))) {
                        this.consultantId = Number(consultantId);
                        //console.log("Loading consultant dash, consultantId:", this.consultantId);
                        this.prevConsultantId = consultantId;
                        this.$store.dispatch('LOAD_SETTINGS', consultantId).then(() => {
                            this.widgetReady = true;
                        });
                    }
                },
                immediate: true
            }
        }
    }
</script>
<style>

</style>
